import { render, staticRenderFns } from "./participant-info.vue?vue&type=template&id=4d744f56&scoped=true&"
import script from "./participant-info.vue?vue&type=script&lang=js&"
export * from "./participant-info.vue?vue&type=script&lang=js&"
import style0 from "./participant-info.vue?vue&type=style&index=0&id=4d744f56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d744f56",
  null
  
)

component.options.__file = "participant-info.vue"
export default component.exports